/** Shared location and user field maps for law-firm creation flows (Phase 9.13F). */

export const LAW_FIRM_USER_POSITION_OPTIONS = ['Paralegal', 'Attorney', 'Clerical Staff'];

export const LAW_FIRM_LOCATION_ADDRESS_REQUIRED_KEYS = [
  'address',
  'zipCode',
  'city',
  'state',
  'county',
];

export const DEFAULT_ACCOUNTING_CONTACT = { name: '', email: '', phone: '' };

export const DEFAULT_ADDRESS_TYPES = { physical: false, mailing: false, billing: false };

export const REGISTER_LAW_FIRM_REQUIRED_FIELDS = ['name', 'address', 'city', 'state', 'zip'];

export const REGISTER_LAW_FIRM_LOCATION_FIELD_KEYS = ['address', 'city', 'state', 'zip', 'phone'];

export function createEmptyLocation(name = 'Other Location') {
  return {
    name,
    address: '',
    zipCode: '',
    city: '',
    county: '',
    state: '',
    phone: '',
    fax: '',
    customerNumber: null,
    useSeparateAccounting: false,
    accountingContact: { ...DEFAULT_ACCOUNTING_CONTACT },
    addressTypes: { ...DEFAULT_ADDRESS_TYPES },
  };
}

export function createEmptyLawFirmRegisterLocation() {
  return {
    name: '',
    website: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
  };
}

export function createEmptyLawFirmUser() {
  return {
    prefix: '',
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    useFirmEmail: false,
    firmEmail: '',
    phoneNumber: '',
    extension: '',
    position: '',
    permissionLevel: 'User',
    isLegalService: false,
    isDefault: false,
    lawschool: '',
    barNumber: '',
    selectedProfessional: '',
    showCustomForm: false,
    is_gia_on_file: false,
    gia_document_link: '',
    gia_document_name: '',
    gia_file: null,
    is_loa_on_file: false,
    loa_document_link: '',
    loa_document_name: '',
    loa_file: null,
    location: '',
    sendInvite: false,
  };
}

export function validateLocationAddressFields(location) {
  return {
    address: !(location.address && String(location.address).trim()),
    zipCode: !(location.zipCode && String(location.zipCode).trim()),
    city: !(location.city && String(location.city).trim()),
    state: !(location.state && String(location.state).trim()),
    county: !(location.county && String(location.county).trim()),
  };
}

export function hasLocationAddressErrors(errors) {
  return errors.address || errors.zipCode || errors.city || errors.state || errors.county;
}

export function mapLocationFormToApiPayload(location, lawfirmId) {
  return {
    lawfirm_id: lawfirmId,
    name: location.name,
    address: location.address,
    zip_code: location.zipCode,
    city: location.city,
    county: location.county,
    state: location.state,
    phone: location.phone,
    fax: location.fax,
    customer_number: location.customerNumber,
    use_separate_firm_accounting_contact: location.useSeparateAccounting,
    accounting_contact_full_name: location.accountingContact.name,
    accounting_contact_email: location.accountingContact.email,
    accounting_contact_phone: location.accountingContact.phone,
    is_physical_address: location.addressTypes.physical,
    is_mailing_address: location.addressTypes.mailing,
    is_billing_address: location.addressTypes.billing,
    is_active: true,
  };
}

export function buildLawFirmUserPreferredName(user) {
  return [user.prefix, user.firstName, user.middleName, user.lastName, user.suffix]
    .filter(Boolean)
    .join(' ');
}

export function isRegisterLawFirmLocationComplete(lawFirm) {
  return REGISTER_LAW_FIRM_REQUIRED_FIELDS.every(
    (key) => lawFirm[key] && String(lawFirm[key]).trim()
  );
}
